module.exports = __webpack_public_path__ + "static/media/practicaFbClusters.5243983b.r";